// extracted by mini-css-extract-plugin
export default {"container":"N0-z","title":"O0-z","link":"P0-z"};